module.exports = __webpack_public_path__ + "static/media/krx-trading-investor-02.f730b1a9.jpg";